import { createSlice } from '@reduxjs/toolkit';

import AccountClientRequests from '@api/requests';

import { AuthFormsStateType } from './authForms.interfaces';

const initialState: AuthFormsStateType = {
	reset_password_type: undefined,
	slug: undefined,
};

export const { actions: authActions, reducer: authFormsReducer } = createSlice({
	name: 'authForms',
	initialState,
	reducers: {},
	extraReducers: builder =>
		builder
			.addCase(AccountClientRequests.AuthForms.getAuthFormBySlug.fulfilled, (state, { payload }) => {
				state.reset_password_type = payload.form.reset_password_type;
				state.slug = payload.form.slug;
			})
			.addCase(AccountClientRequests.AuthForms.getAuthFormBySlug.rejected, state => {
				state.reset_password_type = undefined;
				state.slug = undefined;
			}),
});
